import { gql } from "@apollo/client";

export const MUTATE_RATING = gql`
  mutation SubmitRating($eventId: ObjectID!, $rating: Float!) {
    rateEvent(eventId: $eventId, rating: $rating) {
      ... on EventRating {
        eventId
        userId
        rating
      }
      ... on GQLError {
        __typename
        message
      }
    }
  }
`;
